import { reactive } from 'vue'

/**
 * 搜索组合式函数
 * @param {Object} options 配置选项
 * @param {Object} options.initialForm 初始搜索表单数据
 * @param {Function} options.onSearch 搜索回调函数
 * @returns 搜索状态和方法
 */
export function useSearch(options = {}) {
  const { initialForm = {}, onSearch } = options

  // 搜索表单状态
  const searchForm = reactive({
    keyword: '',
    page: 1,
    size: 20,
    ...initialForm
  })

  // 原始表单数据（用于重置）
  const originalForm = { ...searchForm }

  // 执行搜索
  const handleSearch = () => {
    searchForm.page = 1
    onSearch?.()
  }

  // 重置搜索
  const resetSearch = () => {
    Object.assign(searchForm, { ...originalForm, keyword: '' })
    handleSearch()
  }

  // 更新搜索字段
  const updateField = (key, value) => {
    searchForm[key] = value
  }

  // 获取搜索参数（过滤空值）
  const getSearchParams = (extraFields = {}) => {
    const params = { ...searchForm }
    // 过滤空值
    Object.keys(params).forEach(key => {
      if (params[key] === '' || params[key] === null || params[key] === undefined) {
        delete params[key]
      }
    })
    return { ...params, ...extraFields }
  }

  return {
    searchForm,
    handleSearch,
    resetSearch,
    updateField,
    getSearchParams
  }
}
